// src/components/layout/SiteHeader/SiteHeader.tsx
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "features/auth/hooks/useAuth";

import logoHysteron from "../../../assets/main_page_title.svg";

// The logo always takes an operator back to the admin home.
export const ADMIN_HOME_PATH = "/admin";

const SiteHeader: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <header className="w-full bg-transparent relative z-30">
      <div className="w-full px-5 sm:px-10 md:px-12 pt-6 sm:pt-10 md:pt-12 pb-2 sm:pb-3 md:pb-4">
        <div className="flex items-center justify-between h-12">
          <Link to={ADMIN_HOME_PATH} aria-label="Go to admin home" className="inline-flex items-center">
            <img src={logoHysteron} alt="Hysteron" className="h-10 sm:h-12 md:h-14 w-auto" />
          </Link>

          {user && (
            <button
              type="button"
              onClick={handleSignOut}
              className={[
                "inline-flex items-center",
                "px-4 py-2",
                "rounded-full border-[1.5px] border-[#f3dfae]/90 bg-transparent",
                "text-[#f3dfae]",
                "hover:bg-white/10 transition-colors",
                "font-manrope font-normal uppercase",
                "tracking-[0.08em] text-[11px] leading-none"
              ].join(" ")}
            >
              Sign out
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default SiteHeader;
